const AppConfig = {
  apiUrl: process.env.REACT_APP_API_URL || "",
  refreshTokenTimer:  1200000,
  websocketPingTimer: 180000, // Every 1 Min
  websocketUri: process.env.REACT_APP_WEBSOCKET_URI || "",
  poolData: {
    UserPoolId: process.env.REACT_APP_USER_POOL_ID || "",
    ClientId: process.env.REACT_APP_CLIENT_ID || "",
  },
  OpenAI: process.env.REACT_APP_OPEN_AI || "",
  OpenAIBaseUrl: process.env.REACT_APP_OPEN_AI_BASE_URL || "",
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY || "",
  applicationUIBaseUrl: process.env.REACT_APP_APPLICATION_UI_BASE_URL || "",
  resetPasswordEmail: process.env.REACT_APP_RESET_PASSWORD_EMAIL || "",
  twoHoursCache: 7200000,
  defaultCacheTimeout: 900000,
  applicationFee: 0.17,
};

export default AppConfig;
